import { render, staticRenderFns } from "./TheSidebarMenuClient.vue?vue&type=template&id=0b92c678&scoped=true"
import script from "./TheSidebarMenuClient.vue?vue&type=script&lang=js"
export * from "./TheSidebarMenuClient.vue?vue&type=script&lang=js"
import style0 from "./TheSidebarMenuClient.vue?vue&type=style&index=0&id=0b92c678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b92c678",
  null
  
)

export default component.exports